<template>
  <path
    :d="pathD"
    :vector-effect="vectorEffect"
  ></path>
</template>

<script>
export default {
  name: 'SvgPath',
  props: {
    // Array of {x, y} points to draw the line through
    pointsXY: Array,
    // Controls how "tight" the curve is between points (0-1)
    // Higher values create smoother curves
    tension: { type: Number, default: 0.35 },
    // Vector effect for stroke scaling
    vectorEffect: { type: String, default: 'none' },
  },
  computed: {
    pathD() {
      const pts = this.pointsXY
      // Handle edge cases
      if (!pts?.length) return ''
      if (pts.length === 1) return `M ${pts[0].x} ${pts[0].y}`

      const t = this.tension
      // Start path at first point
      let d = `M ${pts[0].x} ${pts[0].y}`

      // Generate cubic Bezier curves between each pair of points
      for (let i = 1; i < pts.length; i++) {
        const p0 = pts[i - 1] // Previous point
        const p1 = pts[i] // Current point
        const dx = p1.x - p0.x // Horizontal distance between points

        // Calculate control points for the cubic Bezier curve
        // Control points are pulled inward based on tension
        // This creates a smooth curve between the points
        const c1x = p0.x + dx * t // First control point x
        const c2x = p1.x - dx * t // Second control point x

        // Add cubic Bezier curve command to path
        // Format: C c1x,c1y c2x,c2y x,y
        // Where c1 and c2 are control points, and x,y is the end point
        d += ` C ${c1x} ${p0.y}, ${c2x} ${p1.y}, ${p1.x} ${p1.y}`
      }
      return d
    },
  },
}
</script>
